import React from "react";
import StepHeader from "../components/StepHeader";
import ContinueButton from "../components/ContinueButton";

const HOW_IT_WORKS = [
  { title: "Choose account type", subtitle: "Individual or Corporate" },
  { title: "Answer 2 eligibility questions", subtitle: "Income and assets set your classification" },
  { title: "Complete verification", subtitle: "ID, liveness and AML, or company documents and UBOs" },
];

/** Start-screen copy when an earlier approval was closed and the user must verify again. */
const RE_KYC_COPY = {
  DOCUMENT_EXPIRED: "The ID document you verified with has expired. Please verify again with a valid document.",
  ADMIN_REKYC: "Our compliance team needs you to verify your account again.",
};

/**
 * I-01 — intro. "Do it later" (or X) skips for now; the user is asked again at the next login.
 * With `reKycReason` it explains why a verified user has to verify again.
 */
function StartStep({ onStart, onClose, reKycReason }) {
  const isReKyc = Boolean(reKycReason);

  return (
    <>
      <StepHeader title="Account verification" onClose={onClose} />

      <div className="kv-body kv-body--center">
        <div className={`kv-hero-icon${isReKyc ? " kv-hero-icon--warning" : ""}`} aria-hidden="true">
          <i className={isReKyc ? "ri-refresh-line" : "ri-shield-check-line"} />
        </div>

        <p className={`kv-eyebrow${isReKyc ? " kv-eyebrow--warning" : ""}`}>
          {isReKyc ? "Verification renewal" : "VARA onboarding"}
        </p>
        <h2 className="kv-title">{isReKyc ? "Verify your account again" : "Verify your account to start trading"}</h2>
        <p className="kv-lead">
          {isReKyc
            ? RE_KYC_COPY[reKycReason] || RE_KYC_COPY.DOCUMENT_EXPIRED
            : "AGCX operates under Dubai VARA rules. We need a few details to classify your account and verify who you are."}
        </p>

        <ol className="kv-card kv-how-list">
          {HOW_IT_WORKS.map((item, index) => (
            <li key={item.title}>
              <span className="kv-how-list__number">{index + 1}</span>
              <span>
                <strong>{item.title}</strong>
                <small>{item.subtitle}</small>
              </span>
            </li>
          ))}
        </ol>
      </div>

      <ContinueButton
        onClick={onStart}
        secondaryAction={{ label: "Do it later", onClick: onClose }}
        footnote="Your data is encrypted and stored securely."
      >
        Verify now
      </ContinueButton>
    </>
  );
}

export default StartStep;
